export class SoundConstants {
    static readonly GAME_INTRO = 'Intro_transition';
    static readonly SPIN_REEL = 'reel_spinning';
    static readonly WIN_AMOUNT_DISAPPEARS = 'win_amount_disappears';
    static readonly REVEAL_MULTIPLIER = 'reveal_multiplier';
    static readonly MULTIPLIERS_MOVE = 'multipliers_move';
    static readonly MULTIPLIER_BOOST = 'multiplier_boost';
    static readonly GUNSLINGER = 'OR_gunslinger';
    static readonly BIG_WIN_EXIT = 'OR_big_win_exit';
    static readonly BIG_WIN_INTRO = 'OR_big_win_intro';
    static readonly TEXT_DISAPPEAR = 'OR_bonus_text_disappears';
    static readonly TEXT_APPEAR = 'OR_bonus_text_appears';
    static readonly FREEGAME_AMBIENT = 'free_music_ambient';
    static readonly BASEGAME_AMBIENT = 'base_music_ambient';
    static readonly FG_LOOP = 'free_background_loop';
    static readonly BG_LOOP = 'base_music_loop';
    static readonly FS_TRANSITION = 'FS_TRANSITION';
    static readonly BASE_TRANSITION = 'BASE_TRANSITION';
    static readonly SYMBOL_WIN = 'OR_letter_ricochet';
    static readonly WILD_SYMBOL = 'wild_symbol';
    static readonly WIN_TICKUP = 'win_tickup';
    static readonly SCATTER_LAND = 'scatter_land';
    static readonly SCATTER_SYMBOL = 'scatter_symbol';
    static readonly SCATTER_BLAST = 'scatter_symbol_explodes';
    static readonly BIG_MEGA_WIN_FULL = 'big_mega_win_full';
    static readonly BONUS_TOTAL_WIN = 'bonus_total_win';
    static readonly MULTIPLY_TRANSITION = 'multiply_transition';
    static readonly ROW_DROP = 'row_drop';
    static readonly MULTIPLIER_AMOUNT = 'multiplier_amount';
    static readonly MULTIPLIER_AMOUNT_TALLY = 'multiplier_moves_to_tally';
    static readonly TALLY_TOTALING = 'tally_totaling';
    static readonly TOTAL_DISAPPEAR = 'tally_total_disappears';
    static readonly TALLY_WIN_AMOUNT = 'tally_win_amount';
    static readonly TALLY_COUNTER = 'tally_counter';
}